/**
 * Which sound a block makes.
 *
 * Straight off the block's material: what a thing is made of is what it sounds
 * like, and this file used to carry a second copy of that classification which
 * could disagree with the first.
 */

import { blockMaterial, type Material } from "../block/material.js";
import type { SoundName } from "./synth.js";

const BY_MATERIAL: Readonly<Record<Material, SoundName>> = {
  stone: "breakStone",
  wood: "breakWood",
  glass: "breakGlass",
  // Soil has no sound of its own yet - a spade in earth is closest to the
  // rustle, and this is the line to change when one is synthesised.
  earth: "breakGrass",
  plant: "breakGrass",
  // Cloth is quieter than foliage but nothing here sounds like cloth either.
  cloth: "breakGrass",
  fluid: "breakGrass",
  none: "breakGrass",
};

export function soundForBlock(id: number): SoundName {
  return BY_MATERIAL[blockMaterial(id)];
}
